import { render } from "./preLessonInfo.vue?vue&type=template&id=52e48a0a&scoped=true"
import script from "./preLessonInfo.vue?vue&type=script&lang=js"
export * from "./preLessonInfo.vue?vue&type=script&lang=js"

import "./preLessonInfo.vue?vue&type=style&index=0&id=52e48a0a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e48a0a"]])

export default __exports__